export const AGE_TYPE = {
  BMI_60_MONTH_19_AGE: 'BMI_60_MONTH_19_AGE',
  BMI_GE_19_AGE: 'BMI_GE_19_AGE',
  ZSCORE_60: 'ZSCORE_60',
  ALL: 'ALL'
};

export const AGE_TYPE_CONST = {
  ZSCORE: 'ZSCORE_60',
  BMI_CHILD: 'BMI_60_MONTH_19_AGE',
  BMI_ADULT: 'BMI_GE_19_AGE', 
};

export const HISTORY_TYPE = {
  'FOOD_COMBO': 'FOODCOMBO',
  'NUTRITIONAL_STANDARD': 'NUTRITIONAL_STANDARD'
}

export const UNIT_OPTIONS = [
  { value: 'mg', label: 'mg' },
  { value: 'g', label: 'g' },
  { value: 'ml', label: 'ml' },
  { value: 'l', label: 'l' },
  { value: 'kg', label: 'kg' },
];
